import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';
import { type EventLocation } from '@gonfalon/analytics/types';
import type { UIContextsView } from '@gonfalon/contexts/types';
import type { UIFlagListView } from '@gonfalon/flag-filters/types';
import type { UISegmentsListView } from '@gonfalon/segments/types';

import type { Shortcut } from './types';

interface ShortcutEventInfo {
  type: Shortcut['type'];
  name: Shortcut['name'];
  filters?: UISegmentsListView | UIContextsView | UIFlagListView;
  location?: EventLocation | '';
}

function trackShortcutEvent(event: string, attributes?: ShortcutEventInfo) {
  createTrackerForCategory('Shortcuts')(event, attributes);
}

export function trackShortcutViewed() {
  trackShortcutEvent('Save shortcut viewed');
}

export function trackShortcutClicked({ type, name, filters }: ShortcutEventInfo) {
  trackShortcutEvent('Shortcut clicked', { type, name, filters });
}

export function trackShortcutCreated({ type, name, filters, location }: ShortcutEventInfo) {
  trackShortcutEvent('Shortcut Created', { type, name, filters, location });
}
